

let PDP;
function vuePDP() {
  PDP = Vue.createApp({
    delimiters: ['#{', '}'],
    setup() {
      const pdpNewProductStore = window.pdpNewProduct();

      // ─── Shared stores from pinia.js ───────────────────────────────────────
      const vehicleSearch = window.vehicleSearch();
      const cartTools = window.cartTools();
      const fitmentStore = window.fitmentStore();
      const promoStore = window.promo();
      const promoEndDateRaw = pdpNewProductStore.promoEndDate
        || (typeof pdpPromoEndDateRaw !== 'undefined' ? pdpPromoEndDateRaw : '');
      const pdpPromoEndDate = Vue.ref(promoEndDateRaw ? new Date(promoEndDateRaw).getTime() : null);
      const pdpBestDealText = Vue.ref('');
      const compareStore = window.compareStore();
      const stockStore_ = window.stock(); // used directly in watchers below
      compareStore.loadFromStorage();
      const frontUnavailable = Vue.ref(false)
      const globalTools = window.globalTools();
      const notPuncture = Vue.computed(() => puncture ? false : true)

      const storeSelector = window.storeSelector();



      const serviceStockCheck = () => {
        stockLoading.value = false;
        const inStock = isAlignment || storeSelector.nearestStore?.node?.punctureRepair?.value?.toLowerCase() === 'true';
        if (inStock) {
          stockStatus.value = {
            status: 'inStock',
            storeStock: 36,
            warehouseStock: 0,
            totalAvailable: 36,
          }
        } else {
          stockStatus.value = {
            status: 'outOfStock',
            storeStock: 0,
            warehouseStock: 0,
            totalAvailable: 0,
          }
        }
      }

      const availabilityString = (leadDays) => {
        if (prodType?.toLowerCase()?.includes('wheel') && stockStoreRef?.value?.PDPStock?.[0]?.locations?.[0]?.genericStorage) {
          if (leadDays === 0) return 'Available at Supplier. ETA: Today';
          if (leadDays === 1) return 'Available at Supplier. ETA: Tomorrow';
          if (leadDays < 7) {
            let parsedLead = Date.parse(new Date()) + leadDays * 24 * 60 * 60 * 1000;
            let day = new Date(parsedLead).toLocaleDateString('en-AU', { weekday: 'long' })
            if (day == 'Sunday') return 'Available at Supplier. ETA: Monday'
            return `Available at Supplier. ETA: ${day}`;
          } else return `Available at Supplier. ETA: ${leadDays} days`;
        } else {
          if (leadDays === 0) return 'In Stock';
          else if (leadDays === 1) return 'Available Tomorrow';
          else if (leadDays < 7) {
            let parsedLead = Date.parse(new Date()) + leadDays * 24 * 60 * 60 * 1000;
            let day = new Date(parsedLead).toLocaleDateString('en-AU', { weekday: 'long' })
            if (day == 'Sunday') return 'Available Monday';
            return `Available ${day}`;
          } else return `Available in ${leadDays} days`;
        }
      }

      const gsiCheck = async () => {
        let searchString = window.location.search;

        let params = new URLSearchParams(searchString)

        let gsi = params.get('gsi');

        if (gsi) {
          try {
            let prelocIDs = await fetch(jsonData);
            let locIDs = await prelocIDs.json()
            let index = locIDs.findIndex(obj => obj.node.storeID == gsi)
            if (index > -1) {
              const storeSelect = window.storeSelector();
              let req = `{
	                locations(first:70,near:{latitude:${locIDs[index].node.address.latitude},longitude:${locIDs[index].node.address.longitude}},sortKey:DISTANCE) {
		                edges {
			                node {
                        id
				                address {
                          phone
					                longitude
					                latitude
                          formatted
                          provinceCode
				                }
				                name
                          closedFrom: metafield(namespace:"store",key:"closed_from") {
                            value
                          }
                          closedTo: metafield(namespace:"store",key:"closed_to") {
                            value
                          }
			                }
		                }
	                }
                }`
              const opts = {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP
                },
                body: JSON.stringify({ query: req })
              };
              const storesResponse = await fetch(`${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`, opts);
              let stores = await storesResponse.json()
              stores.data.locations.edges = stores?.data?.locations?.edges?.filter(edge => !edge?.node?.name?.includes("pre-order") && !edge?.node?.name?.includes("warehouse"))

              let storeData = stores.data.locations.edges.map(store => {
                store.node.phoneLink = `tel:${store.node.address.phone}`
                store.node.storeLink = `${shopifyConfig.storeURL}/pages/${store.node.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')}-t-marts`
                store.node.directionLink = `https://maps.google.com.au/maps?q=${store.node.address.latitude},${store.node.address.longitude}&z=15`;
                store.node.closedFrom = store.node.closedFrom?.value;
                store.node.closedTo = store.node.closedTo?.value;
                store.node.isClosed = storeSelect.isLocationClosed(store.node);
                let distance = storeSelect.haversineFormula(Number(locIDs[index].node.address.latitude), Number(locIDs[index].node.address.longitude), store.node.address.latitude, store.node.address.longitude).toFixed(2);
                return { ...store, distance };
              });

              let nearStores = storeData.filter(store => Number(store.distance) < shopifyConfig.storeRadius);
              let storeIndex = nearStores.findIndex(store => store.node.name == locIDs[index].node.name)
              if (storeIndex > -1) {
                storeSelect.updateNearestStore(nearStores[storeIndex]);
                localStorage.setItem('currentNearestStore', JSON.stringify(nearStores[storeIndex]));
                nearStores.splice(storeIndex, 1)
                this.storesWithinDistance = nearStores;
                localStorage.setItem('storesUnder100', JSON.stringify(nearStores))
                if (!localStorage.getItem('currentUserLocation')) {
                  storeSelect.updateLocation({
                    name: locIDs[index].node.name,
                    latitude: locIDs[index].node.address.latitude,
                    longitude: locIDs[index].node.address.longitude
                  })
                  localStorage.setItem('currentUserLocation', JSON.stringify({
                    name: locIDs[index].node.name,
                    latitude: locIDs[index].node.address.latitude,
                    longitude: locIDs[index].node.address.longitude
                  }))
                }
              }


              history.replaceState(null, '', window.location.pathname.replaceAll(`&gsi=${gsi}`, '').replaceAll(`?gsi=${gsi}`, ''))
            }
          } catch (err) {
            console.error(`Error fetching store IDs: ${err}`)
          }
        }
      }

      gsiCheck();

      // ─── Local refs ────────────────────────────────────────────────────────
      const quantity = Vue.ref(['alignment', 'puncture'].some(k => (window.prodHandle || '').includes(k)) ? 1 : 4);
      const discountPrice = Vue.ref(false);
      const productDiscount = Vue.ref(0);
      const showBuyNowModal = Vue.ref(false);
      const showDiscountModal = Vue.ref(false);
      const showDiscountFade = Vue.ref(false);
      const mainCartState = Vue.ref('idle');
      const splitCartState = Vue.ref('idle');
      const isPastAddToCart = Vue.ref(false);
      const showFloatingCart = Vue.computed(() => isPastAddToCart.value && !cartTools.showCart);
      const stockLoading = Vue.ref(true);
      const selectedStore = Vue.ref(null);
      const storeSelectorRef = Vue.ref(null);
      const stockStoreRef = Vue.ref(null);
      const lastStoreId = Vue.ref(null);
      const frontQty = Vue.ref(2);
      const rearQty = Vue.ref(2);
      const rearProduct = Vue.ref(null);
      const alternativeStore = Vue.ref(null);
      const overrideFrontProduct = Vue.ref(null)
      const selectedStoreClosedToDisplay = Vue.computed(() => storeSelector.formatClosedToDate(selectedStore.value?.closedTo));
      const alternativeStoreClosedToDisplay = Vue.computed(() => storeSelector.formatClosedToDate(alternativeStore.value?.closedTo));
      if (puncture) {
        quantity.value = 1;
      }

      const stockStatus = Vue.ref({
        status: 'outOfStock',
        storeStock: 0,
        warehouseStock: 0,
        totalAvailable: 0,
      });
      const rearStockStatus = Vue.ref({
        status: 'outOfStock',
        available: false,
        availableDays: null,
        availableDate: null,
      });

      const productContext = {
        prodId: window.prodId || '',
        prodTitle: window.prodTitle || '',
        prodPrice: window.prodPrice ?? 0,
        prodImage: window.prodImage || '',
        prodVendor: window.prodVendor || '',
        prodType: window.prodType || '',
        wts: window.wts || '',
        prodHandle: window.prodHandle || '',
        prodVariantId: window.prodVariantId || '',
        promoType: pdpNewProductStore.promoType || window.promoType || '',
        promoValue: pdpNewProductStore.promoValue || window.promoValue || 0,
        prodTags: window.prodTags || [],
        prodRimDiameter: window.prodRimDiameter || ''
      };

      const prodId = String(productContext.prodId || '');
      const prodTitle = String(productContext.prodTitle || '');
      const prodPrice = Number(productContext.prodPrice || 0);
      const prodImage = String(productContext.prodImage || '');
      const prodVendor = String(productContext.prodVendor || '');
      const prodType = String(productContext.prodType || '');
      const wts = String(productContext.wts || '');
      const prodHandle = String(productContext.prodHandle || '');
      const prodVariantId = String(productContext.prodVariantId || '');
      const promoType = String(productContext.promoType || '');
      const promoValue = Number(productContext.promoValue || 0);
      const prodTags = Array.isArray(productContext.prodTags) ? productContext.prodTags : [];
      const prodRimDiameter = String(productContext.prodRimDiameter || '');
      const isAlignment = prodHandle.includes('alignment');
      const isServiceProduct = isAlignment || prodHandle.includes('puncture');
      const unitLabelSingular = prodType.toLowerCase().includes('wheel') ? 'wheel' : 'tyre';

      // priceFormat comes from promoStore (pinia.js) — no local duplicate needed
      const priceFormat = promoStore.priceFormat;
      const productIdNumber = prodId ? prodId.replace('gid://shopify/Product/', '') : '';
      const normalizeCompareProductId = (value) => String(value || '').replace('gid://shopify/Product/', '');
      const prevCollectionStripProducts = Vue.ref([]);
      const prevCollectionStripLoading = Vue.ref(true);
      const prevCollectionStripTrackRef = Vue.ref(null);

      const parsePrevCollectionConfig = () => {
        const keyPrimary = `${window.name || ''}prevCollectionConfig`;
        const keyFallback = 'prevCollectionConfig';
        const raw = localStorage.getItem(keyPrimary) || localStorage.getItem(keyFallback);
        if (!raw) return null;
        try {
          const parsed = JSON.parse(raw);
          if (!parsed || typeof parsed !== 'object') return null;
          if (!parsed.handle) return null;
          return parsed;
        } catch (e) {
          return null;
        }
      };

      const buildPrevCollectionFilterString = (config) => {
        const filterParts = [];
        const vehicleFilters = [...new Set((config?.vehicleFilters || []).filter(Boolean))];
        for (let i = 0; i < vehicleFilters.length; i++) {
          filterParts.push(`{productMetafield:{namespace:"wts",key:"sf",value:"${String(vehicleFilters[i] || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"')}"}}`);
        }

        const pageFilters = Array.isArray(config?.pageFilters) ? config.pageFilters : [];
        for (let i = 0; i < pageFilters.length; i++) {
          try {
            const input = JSON.parse(pageFilters[i]);
            const topKey = Object.keys(input || {})[0];
            const topVal = topKey ? input[topKey] : null;
            if (!topKey || topVal === null || topVal === undefined) continue;

            if (typeof topVal === 'object' && !Array.isArray(topVal)) {
              const nestedParts = [];
              const nestedKeys = Object.keys(topVal);
              for (let n = 0; n < nestedKeys.length; n++) {
                const nestedKey = nestedKeys[n];
                const nestedVal = topVal[nestedKey];
                nestedParts.push(`${nestedKey}:"${String(nestedVal || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"')}"`);
              }
              filterParts.push(`{${topKey}:{${nestedParts.join(',')}}}`);
            } else {
              filterParts.push(`{${topKey}:"${String(topVal || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"')}"}`);
            }
          } catch (e) { }
        }

        const handleLower = String(config?.handle || '').toLowerCase();
        const isWheelHandle = handleLower.includes('wheel') || handleLower.endsWith('w');
        if (!isWheelHandle && vehicleFilters.length > 0) {
          filterParts.push(`{productMetafield:{namespace:"tyre_spec",key:"run_flat",value:"${config?.runFlat ? 'true' : 'false'}"}}`);
        }

        filterParts.push('{available:true}');
        filterParts.push('{available:false}');

        return filterParts.join(',');
      };

      const enrichStripPromo = (basePriceRaw, promoTypeRaw, promoValueRaw, promoTitleRaw, promoColourRaw) => {
        const basePrice = Number(basePriceRaw || 0);
        const promoType = String(promoTypeRaw || '').trim();
        const promoTitle = String(promoTitleRaw || '').trim();
        const promoColour = String(promoColourRaw || '').trim();
        const promoValue = Number(promoValueRaw || 0);
        const promoTypeLower = promoType.toLowerCase();
        let promo = false;
        let promoUnitPrice = basePrice;
        let savingValue = 0;
        if (promoTypeLower === 'cash back') {
          promoUnitPrice = ((basePrice * 4) - promoValue) / 4;
          savingValue = promoValue;
          promo = true;
        } else if (promoTypeLower === 'percentage') {
          const saving = (basePrice * 4) * (promoValue / 100);
          promoUnitPrice = ((basePrice * 4) - saving) / 4;
          savingValue = saving;
          promo = true;
        } else if (promoTypeLower === 'buy 3 get 4') {
          promoUnitPrice = ((basePrice * 3) + 25) / 4;
          savingValue = basePrice - 25;
          promo = true;
        } else if (promoTypeLower === 'other') {
          promo = true;
        }
        return {
          promo,
          promoType,
          promoTitle,
          promoColour,
          savingDisplay: savingValue > 0 ? priceFormat(savingValue) : '',
          displayPrice: promo && Number.isFinite(promoUnitPrice) ? promoUnitPrice : basePrice,
        };
      };

      const PERF_METRIC_FIELDS = pdpNewProductStore.perfMetricFields;

      const extractPerfMetrics = (perf) => {
        const metrics = {};
        PERF_METRIC_FIELDS.forEach(([key, suffix]) => {
          metrics[`perf${suffix}`] = perf?.[key]?.value || '';
        });
        return metrics;
      };

      const fetchPrevCollectionStrip = async () => {
        const config = parsePrevCollectionConfig();
        if (!config) {
          prevCollectionStripProducts.value = [];
          prevCollectionStripLoading.value = false;
          return;
        }

        const configHandleLower = String(config.handle || '').toLowerCase();
        const configIsWheel = configHandleLower.includes('wheel') || configHandleLower.endsWith('w');
        const currentIsWheel = prodType.toLowerCase().includes('wheel');
        if (configIsWheel !== currentIsWheel) {
          prevCollectionStripProducts.value = [];
          prevCollectionStripLoading.value = false;
          return;
        }

        const filters = buildPrevCollectionFilterString(config);
        const allowedSortKeys = ['BEST_SELLING', 'CREATED', 'PRICE', 'PRODUCT_TYPE', 'RELEVANCE', 'TITLE', 'CREATED_AT', 'MANUAL'];
        const incomingSortKey = String(config.sortKey || 'BEST_SELLING').toUpperCase();
        const sortKey = allowedSortKeys.includes(incomingSortKey) ? incomingSortKey : 'BEST_SELLING';
        const reverse = !!config.descending;
        const query = `{
          collection(handle:"${config.handle}") {
            products(first:24, sortKey:${sortKey}, reverse:${reverse}, filters:[${filters}]) {
              edges {
                node {
                  id
                  title
                  tags
                  handle
                  vendor
                  productType
                  images(first:1) {
                    edges {
                      node {
                        url
                        altText
                      }
                    }
                  }
                  priceRange {
                    minVariantPrice {
                      amount
                    }
                  }
                  collections(first:50) {
                    edges {
                      node {
                        promoType: metafield(namespace:"promotion", key:"type") { value }
                        promoValue: metafield(namespace:"promotion", key:"value") { value }
                        promoTitle: metafield(namespace:"promotion", key:"title") { value }
                        promoColour: metafield(namespace:"promotion", key:"colour") { value }
                      }
                    }
                  }
                  pdpPerformance: metafield(namespace:"pdp", key:"performance") { value }
                }
              }
            }
          }
        }`;

        try {
          prevCollectionStripLoading.value = true;
          const response = await fetch(`${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP,
            },
            body: JSON.stringify({ query }),
          });
          if (!response.ok) {
            prevCollectionStripProducts.value = [];
            return;
          }

          const data = await response.json();
          const edges = data?.data?.collection?.products?.edges || [];
          const mapped = edges
            .map((edge) => edge?.node)
            .filter((node) => node)
            .map((node) => {
              const promoEdge = (node?.collections?.edges || []).find((edge) => edge?.node?.promoType?.value);
              const promoMeta = enrichStripPromo(
                node?.priceRange?.minVariantPrice?.amount,
                promoEdge?.node?.promoType?.value,
                promoEdge?.node?.promoValue?.value,
                promoEdge?.node?.promoTitle?.value,
                promoEdge?.node?.promoColour?.value
              );
              const title = String(node?.title || '').trim();
              let perfMetrics = extractPerfMetrics({});
              try {
                const parsedDetails = node?.pdpPerformance?.value ? JSON.parse(node.pdpPerformance.value) : null;
                perfMetrics = extractPerfMetrics(parsedDetails?.performance || {});
              } catch (e) { }
              return {
                id: String(node.id || '').replace('gid://shopify/Product/', ''),
                title,
                handle: node.handle || '',
                vendor: node.vendor || '',
                productType: node.productType || '',
                image: node?.images?.edges?.[0]?.node?.url || '',
                imageAlt: node?.images?.edges?.[0]?.node?.altText || title || '',
                price: Number(node?.priceRange?.minVariantPrice?.amount || 0),
                displayPrice: promoMeta.displayPrice,
                promo: promoMeta.promo,
                promoType: promoMeta.promoType,
                promoTitle: promoMeta.promoTitle,
                promoColour: promoMeta.promoColour,
                savingDisplay: promoMeta.savingDisplay,
                ...perfMetrics,
                isCurrent: false,
              };
            })
            .filter((node) => !!node.handle);

          const dedupedMap = new Map();
          mapped.forEach((item) => {
            if (!item?.id) return;
            if (!dedupedMap.has(item.id)) dedupedMap.set(item.id, item);
          });
          const deduped = Array.from(dedupedMap.values());

          const currentFromList = deduped.find((item) => item.id === productIdNumber) || null;
          let currentItem = currentFromList;
          if (!currentItem) {
            const currentPromoMeta = enrichStripPromo(prodPrice, promoType, promoValue, '', '');
            const currentTitle = String(prodTitle || '').trim();
            currentItem = {
              id: productIdNumber,
              title: currentTitle,
              handle: prodHandle,
              vendor: prodVendor,
              productType: prodType,
              image: prodImage,
              imageAlt: currentTitle,
              price: Number(prodPrice || 0),
              displayPrice: currentPromoMeta.displayPrice,
              promo: currentPromoMeta.promo,
              promoType: currentPromoMeta.promoType,
              promoTitle: currentPromoMeta.promoTitle,
              promoColour: currentPromoMeta.promoColour,
              savingDisplay: currentPromoMeta.savingDisplay,
              isCurrent: true,
            };
          } else {
            currentItem = { ...currentItem, isCurrent: true };
          }
          PERF_METRIC_FIELDS.forEach(([, suffix]) => {
            const key = `perf${suffix}`;
            const fromStore = pdpNewProductStore.perfMetricsByKey[suffix]?.value;
            currentItem[key] = fromStore || window[`pdpPerf${suffix}`] || currentItem[key] || '';
          });

          const others = deduped.filter((item) => item.id !== currentItem.id);
          const currentPriceForSplit = Number(currentItem.displayPrice || currentItem.price || 0);
          const cheaper = others
            .filter((item) => Number(item.displayPrice || item.price || 0) < currentPriceForSplit)
            .sort((a, b) => Number(a.displayPrice || a.price || 0) - Number(b.displayPrice || b.price || 0));
          const expensive = others
            .filter((item) => Number(item.displayPrice || item.price || 0) >= currentPriceForSplit)
            .sort((a, b) => Number(a.displayPrice || a.price || 0) - Number(b.displayPrice || b.price || 0));

          prevCollectionStripProducts.value = [...cheaper, currentItem, ...expensive];
          Vue.nextTick(() => {
            centerCurrentStripCard('auto');
            setTimeout(() => centerCurrentStripCard('auto'), 80);
            setTimeout(() => centerCurrentStripCard('auto'), 260);
          });
        } catch (e) {
          prevCollectionStripProducts.value = [];
        } finally {
          prevCollectionStripLoading.value = false;
        }
      };

      const formatStripPrice = (value) => priceFormat(Number(value || 0));

      const compareTableRows = Vue.computed(() => {
        if (isServiceProduct) return [];
        const list = prevCollectionStripProducts.value || [];
        const idx = list.findIndex((item) => item.isCurrent);
        if (idx === -1) return [];
        const above = list[idx + 1] || null;
        const current = list[idx];
        const below = list[idx - 1] || null;
        return [above, current, below].filter(Boolean);
      });

      const openFullCompare = () => {
        const rows = compareTableRows.value;
        if (!rows.length) return;
        compareStore.selectedProducts = rows.map((item) => ({
          id: item.id,
          title: item.title,
          price: Number(item.displayPrice || item.price || 0),
          featured_image: item.image,
          vendor: item.vendor,
          handle: item.handle,
          available: true,
        }));
        compareStore.persist();
        compareStore.isCompareModalOpen = true;
      };

      const centerCurrentStripCard = (behavior = 'auto') => {
        const track = prevCollectionStripTrackRef.value;
        if (!track) return;
        const currentCard = track.querySelector('.pdpPrevCollectionCard.is-current');
        if (!currentCard) return;
        const cardCenter = currentCard.offsetLeft + (currentCard.offsetWidth / 2);
        const targetLeft = cardCenter - (track.clientWidth / 2);
        const maxLeft = Math.max(0, track.scrollWidth - track.clientWidth);
        const clampedLeft = Math.min(Math.max(targetLeft, 0), maxLeft);
        track.scrollTo({ left: clampedLeft, behavior });
      };

      const scrollPrevCollectionStrip = (direction) => {
        const el = prevCollectionStripTrackRef.value;
        if (!el) return;
        const step = Math.max(220, Math.floor(el.clientWidth * 0.75));
        el.scrollBy({
          left: direction === 'left' ? -step : step,
          behavior: 'smooth',
        });
      };

      // ─── Compare helpers — delegate to compareStore (pinia.js) ────────────
      // isInCompare & toggleCompare mirror collection.js but scoped to this product.
      const isInCompare = Vue.computed(() =>
        compareStore?.selectedProducts.some((p) => normalizeCompareProductId(p.id || p.node?.id) === productIdNumber)
      );

      const toggleCompare = () => {
        if (!productIdNumber) return;
        const existingIndex = compareStore?.selectedProducts.findIndex(
          (p) => normalizeCompareProductId(p.id || p.node?.id) === productIdNumber
        );
        if (existingIndex > -1) {
          compareStore.selectedProducts.splice(existingIndex, 1);
          compareStore.persist();
          if (!compareStore.selectedProducts.length) {
            compareStore.isDrawerOpen = false;
            compareStore.persist();
          }
          return;
        }
        if (compareStore.selectedProducts.length >= 3) {
          compareStore.showCompareLimitDialog('You can only compare up to 3 tyres');
          return;
        }
        compareStore.selectedProducts.push({
          id: productIdNumber,
          title: prodTitle,
          price: Number(prodPrice),
          featured_image: prodImage,
          vendor: prodVendor,
          available: true,
        });
        compareStore.openCompareDrawer();
      };

      // ─── openStoreSelector — same implementation as collection.js ──────────
      const openStoreSelector = () => {
        const button = document.getElementById('my-store-btn');
        if (button) {
          button.scrollIntoView({ behavior: 'smooth', block: 'center' });
          button.click();
        }
      };


      const buttonValue = Vue.computed(() => {
        const qty = Number(quantity.value) || 0;
        const baseTotal = Number(prodPrice) * qty;
        const savings = Number(productDiscount.value) || 0;
        return priceFormat(Math.max(0, baseTotal - savings));
      });

      const productDiscountDisplay = Vue.computed(() => priceFormat(Number(productDiscount.value)));
      const currentPriceDisplay = Vue.computed(() => priceFormat(Number(prodPrice)));
      const afterpayInstallmentDisplay = Vue.computed(() => priceFormat(Number(prodPrice) / 4));

      const parseMatchValues = (value) => {
        if (!value) return [];
        if (Array.isArray(value)) return value.filter(Boolean).map((v) => String(v));
        if (typeof value === 'string') {
          const trimmed = value.trim();
          if (!trimmed) return [];
          if (trimmed.startsWith('[')) {
            try {
              const parsed = JSON.parse(trimmed);
              if (Array.isArray(parsed)) return parsed.filter(Boolean).map((v) => String(v));
            } catch (e) { }
          }
          return [trimmed];
        }
        if (value.matches && Array.isArray(value.matches)) {
          return value.matches.filter(Boolean).map((v) => String(v));
        }
        return [];
      };

      const getActiveVehicle = () => {
        const activeVehicleId = localStorage.getItem('activeVehicleId');
        if (!activeVehicleId) return null;
        const liveVehicles = Array.isArray(vehicleSearch.vehicles) ? vehicleSearch.vehicles : [];
        const liveMatch = liveVehicles.find((v) => String(v?.id) === String(activeVehicleId));
        try {
          const storedVehicles = JSON.parse(localStorage.getItem('vehicles') || '[]');
          if (Array.isArray(storedVehicles)) {
            const storedMatch = storedVehicles.find((v) => String(v?.id) === String(activeVehicleId)) || null;
            if (storedMatch?.fitmentInfo) return storedMatch;
          }
        } catch (e) { }
        return liveMatch || null;
      };

      const getRimFromText = (value) => {
        const text = String(value || '');
        if (!text) return null;
        const tyreMatch = text.toUpperCase().match(/R\s*(\d{2})\b/);
        if (tyreMatch) return Number(tyreMatch[1]);
        const wheelMatch = text.match(/(\d{2})(?:\s*inch|\b)/i);
        if (wheelMatch) return Number(wheelMatch[1]);
        return null;
      };

      const getSelectedFitmentRims = () => {
        const selectedFitment = fitmentStore?.selectedFitment;
        if (!selectedFitment) return [];
        const rims = [];
        const front = selectedFitment.fullSize || selectedFitment.size || '';
        const rear = selectedFitment.fullRearSize || selectedFitment.rearSize || '';
        const frontRim = getRimFromText(front);
        const rearRim = getRimFromText(rear);
        if (frontRim) rims.push(frontRim);
        if (rearRim) rims.push(rearRim);
        return Array.from(new Set(rims));
      };

      const normalizeFitmentValue = (value) =>
        String(value || '')
          .replaceAll('/', 'x')
          .replaceAll(' ', '_')
          .toUpperCase();

      const expandFitmentValues = (values) => {
        const out = [];
        for (let i = 0; i < values.length; i++) {
          const normalized = normalizeFitmentValue(values[i]);
          if (!normalized) continue;
          out.push(normalized);
          const stripped = normalized.replace(/_(\d+)[A-Z]+$/i, '_$1');
          if (stripped !== normalized) out.push(stripped);
        }
        return Array.from(new Set(out));
      };

      const getSelectedFitmentMatchValues = () => {
        const selectedFitment = fitmentStore?.selectedFitment;
        if (selectedFitment?.rawData) {
          const raw = selectedFitment.rawData;
          const front = raw?.f_tyres?.matches || raw?.f_wheels?.matches || [];
          const rear = selectedFitment.isSplit ? (raw?.r_tyres?.matches || raw?.r_wheels?.matches || []) : [];
          return expandFitmentValues([...parseMatchValues(front), ...parseMatchValues(rear)]);
        }

        const vehicle = getActiveVehicle();
        const fitmentInfo = vehicle?.fitmentInfo;
        const isWheelProduct = String(prodType || '').toLowerCase().includes('wheel');
        const fitment = isWheelProduct
          ? fitmentInfo?.wheel_fitments?.[0]
          : fitmentInfo?.tyre_fitments?.[0];
        if (!fitment) return [];
        const front = fitment?.f_tyres?.matches || fitment?.f_wheels?.matches || [];
        const rear = fitment?.is_split ? (fitment?.r_tyres?.matches || fitment?.r_wheels?.matches || []) : [];
        return expandFitmentValues([...parseMatchValues(front), ...parseMatchValues(rear)]);
      };

      const getProductFitmentMatchValues = () => expandFitmentValues(parseMatchValues(wts));

      const getServiceFitStatus = (categoryKey) => {
        const vehicle = getActiveVehicle();
        if (!vehicle?.make?.display_name || !vehicle?.model?.display_name || !vehicle?.manufactureYear) return 'none';
        const value = Array.isArray(vehicle?.categories)
          ? vehicle.categories.find((c) => c?.key === categoryKey)?.value
          : null;
        if (!value) return 'none';
        return prodTags.some((t) => String(t).toLowerCase() === `${categoryKey}:${value}`) ? 'fit' : 'notFit';
      };

      const vehicleFitStatus = Vue.computed(() => {
        const activeVehicleId = localStorage.getItem('activeVehicleId');
        if (!activeVehicleId) return 'none';

        if (prodHandle.includes('alignment')) return getServiceFitStatus('wa');
        if (prodHandle.includes('puncture')) return getServiceFitStatus('pr');

        const vehicle = getActiveVehicle();
        if (!vehicle?.make?.display_name || !vehicle?.model?.display_name || !vehicle?.manufactureYear) {
          return 'none';
        }

        const isWheelProduct = String(prodType || '').toLowerCase().includes('wheel');
        if (isWheelProduct) {
          const wheelFit = vehicle?.fitmentInfo?.wheel_fitments?.[0];
          const wheelRims = [];
          const frontWheelDesc = wheelFit?.f_wheels?.desc || wheelFit?.f_wheels?.full_desc || '';
          const rearWheelDesc = wheelFit?.r_wheels?.desc || wheelFit?.r_wheels?.full_desc || '';
          const frontWheelRim = getRimFromText(frontWheelDesc);
          const rearWheelRim = getRimFromText(rearWheelDesc);
          if (frontWheelRim) wheelRims.push(frontWheelRim);
          if (rearWheelRim) wheelRims.push(rearWheelRim);

          const selectedRims = getSelectedFitmentRims();
          const parsedRim = Number(prodRimDiameter);
          const productRim = Number.isFinite(parsedRim) && parsedRim > 0
            ? parsedRim
            : (getRimFromText(prodTitle) || getRimFromText(wts));

          if (!productRim) return 'fit';
          const wheelDescMatch = wheelRims.length ? wheelRims.includes(productRim) : true;
          const selectedFitmentRMatch = selectedRims.length ? selectedRims.includes(productRim) : true;
          return wheelDescMatch && selectedFitmentRMatch ? 'fit' : 'notFit';
        }

        const selectedMatches = getSelectedFitmentMatchValues();
        const productMatches = getProductFitmentMatchValues();
        if (!selectedMatches.length || !productMatches.length) return 'fit';
        return selectedMatches.some((match) => productMatches.includes(match)) ? 'fit' : 'notFit';
      });

      const vehicleFitLabel = Vue.computed(() => {
        const activeVehicleId = localStorage.getItem('activeVehicleId');
        if (!activeVehicleId) return '';
        const vehicle = getActiveVehicle();
        if (!vehicle?.make?.display_name || !vehicle?.model?.display_name || !vehicle?.manufactureYear) return '';
        const vehicleName = `${vehicle.make.display_name} ${vehicle.model.display_name} (${vehicle.manufactureYear})`;
        return vehicleFitStatus.value === 'notFit'
          ? `This product may not fit your ${vehicleName}`
          : `Confirmed fit for your ${vehicleName}`;
      });


      const normalizeMatch = (match) => {
        if (!match) return null;
        if (typeof match === 'string' && match.trim().startsWith('[')) {
          try {
            const parsed = JSON.parse(match);
            if (Array.isArray(parsed) && parsed[0]) return parsed[0];
          } catch (e) { }
        }
        return String(match).replace(/[\[\]\"]/g, '');
      };

      const normalizeProductBase = (title) => {
        if (!title) return '';
        return String(title)
          .replace(/\b\d{3}\/\d{2}r\d{2}\b.*$/i, '')
          .replace(/\b\d{2,3}\s*\/\s*\d{2}\s*r\s*\d{2}\b.*$/i, '')
          .replace(/\s+/g, ' ')
          .trim();
      };

      const getSplitFitment = () => {
        if (isServiceProduct) return { isSplit: false };
        const vehicle = vehicleSearch.vehicles?.[0];
        const fitmentInfo = vehicle?.fitmentInfo;
        const isWheelProduct = String(prodType || '').toLowerCase().includes('wheel');
        const tyreSplit = fitmentInfo?.tyre_fitments?.[0]?.is_split ? fitmentInfo.tyre_fitments[0] : null;
        const wheelSplit = fitmentInfo?.wheel_fitments?.[0]?.is_split ? fitmentInfo.wheel_fitments[0] : null;
        const split = isWheelProduct ? (wheelSplit || tyreSplit) : (tyreSplit || wheelSplit);

        if (split?.f_wheels || split?.r_wheels) {
          return {
            isSplit: true,
            frontLabel: split?.f_wheels?.desc || split?.f_wheels?.full_desc || '',
            rearLabel: split?.r_wheels?.desc || split?.r_wheels?.full_desc || '',
            frontMatches: split?.f_wheels?.matches || [],
            rearMatches: split?.r_wheels?.matches || [],
          };
        }
        if (split?.f_tyres || split?.r_tyres) {
          return {
            isSplit: true,
            frontLabel: split?.f_tyres?.desc || split?.f_tyres?.full_desc || '',
            rearLabel: split?.r_tyres?.desc || split?.r_tyres?.full_desc || '',
            frontMatches: split?.f_tyres?.matches || [],
            rearMatches: split?.r_tyres?.matches || [],
          };
        }
        return { isSplit: false };
      };

      const splitFitment = Vue.computed(() => getSplitFitment());
      const isSplitFitment = Vue.computed(() => !!splitFitment.value?.isSplit && !puncture);

      const frontProduct = Vue.computed(() => {
        if (overrideFrontProduct.value) return overrideFrontProduct.value
        return {
          id: productIdNumber,
          title: prodTitle,
          handle: prodHandle,
          price: Number(prodPrice),
          image: prodImage,
          vendor: prodVendor,
          variantId: prodVariantId,
        }
      })

      const frontPriceDisplay = Vue.computed(() => priceFormat(frontProduct.value.price));
      const rearPriceDisplay = Vue.computed(() => priceFormat(rearProduct.value?.price));
      const frontSplitTitle = Vue.computed(() => normalizeProductBase(frontProduct.value?.title) || frontProduct.value?.title || '');
      const rearSplitTitle = Vue.computed(() => normalizeProductBase(rearProduct.value?.title) || rearProduct.value?.title || '');

      const rearSpecReading = Vue.computed(() => {
        const rp = rearProduct.value;
        if (!rp || prodType?.includes('heel')) return '';
        if (!rp.width || !rp.aspectRatio || !rp.rimDiameter) return '';
        let reading = `${rp.width}/${rp.aspectRatio}R${rp.rimDiameter}`;
        if (rp.loadIndex) reading += ` ${rp.loadIndex}`;
        if (rp.speedRating) reading += `${rp.speedRating}`;
        return reading;
      });

      const splitSavings = Vue.computed(() => {
        if (!isSplitFitment.value || !rearProduct.value?.price) return 0;
        if (!promoType || rearProduct.value.promoType !== promoType) return 0;
        const frontPrice = Number(frontProduct.value.price);
        const rearPrice = Number(rearProduct.value.price);
        const setTotal = frontPrice * 2 + rearPrice * 2;
        if (promoType === 'Cash Back') return Number(promoValue);
        if (promoType === 'Percentage') return setTotal * (Number(promoValue) / 100);
        if (promoType === 'Buy 3 Get 4') {
          const lower = Math.min(frontPrice, rearPrice);
          return Number(lower) - 25;
        }
        return 0;
      });

      const splitSavingsDisplay = Vue.computed(() => priceFormat(splitSavings.value));

      const isPurchasableStatus = (status) => status === 'inStock' || status === 'available';

      const effectiveFrontQty = Vue.computed(() =>
        isPurchasableStatus(stockStatus.value.status) ? frontQty.value || 0 : 0
      );
      const effectiveRearQty = Vue.computed(() =>
        isPurchasableStatus(rearStockStatus.value.status) ? rearQty.value || 0 : 0
      );

      const splitTotalDisplay = Vue.computed(() => {
        const fp = Number(frontProduct.value.price) || 0;
        const rp = Number(rearProduct.value?.price || 0);
        const rawTotal = fp * effectiveFrontQty.value + rp * effectiveRearQty.value;
        return priceFormat(rawTotal - splitSavings.value);
      });

      const splitCartLabel = Vue.computed(() => {
        const front = frontQty.value || 0;
        const rear = rearQty.value || 0;
        if (splitCartState.value === 'adding') return 'Adding...';
        if (splitCartState.value === 'added') return 'Added to cart';
        const parts = [];
        if (front > 0) parts.push(`${front} Front`);
        if (rear > 0) parts.push(`${rear} Rear`);
        return `Add ${front + rear} Tyres to Cart${parts.length ? ` (${parts.join(' + ')})` : ''}`;
      });

      const mainCartLabel = Vue.computed(() => {
        if (mainCartState.value === 'adding') return 'Adding...';
        if (mainCartState.value === 'added') return 'Added to cart';
        return 'Add to Cart';
      });

      const canAddSplit = Vue.computed(() => {
        if (stockStatus.value.status === 'limited' || rearStockStatus.value.status === 'limited') return false;
        const total = (effectiveFrontQty.value || 0) + (effectiveRearQty.value || 0);
        const bothLoading = stockStatus.value.status === 'loading' && rearStockStatus.value.status === 'loading';
        return total > 0 && !bothLoading;
      });

      const combinedStockLoading = Vue.computed(() => {
        if (!isSplitFitment.value) return stockLoading.value || stockStatus.value.status === 'loading';
        // For split: front is loading only if not already outOfStock
        const frontLoading = stockStatus.value.status === 'loading';
        // For split: rear is loading only if it exists AND is not already outOfStock
        const rearLoading = !!(rearProduct.value && rearStockStatus.value.status === 'loading');
        return stockLoading.value || frontLoading || rearLoading;
      });

      const overallStockStatus = Vue.computed(() => {
        if (!isSplitFitment.value) return stockStatus.value;
        const front = stockStatus.value || {};
        const rear = rearStockStatus.value || {};

        // Still loading — don't resolve yet
        if (front.status === 'loading' || (rearProduct.value && rear.status === 'loading')) {
          return { status: 'loading', availableDays: null };
        }

        // If no rear product found, only consider front status
        if (!rearProduct.value) return front;

        // If either side is outOfStock, the set cannot be completed — report outOfStock
        if (front.status === 'outOfStock' || rear.status === 'outOfStock') {
          return { status: 'outOfStock', availableDays: null };
        }

        if (front.status === 'limited' || rear.status === 'limited') {
          return { status: 'limited', availableDays: null };
        }

        if (front.status === 'inStock' && rear.status === 'inStock') return { status: 'inStock', availableDays: 0 };
        if (front.status === 'inStock' || rear.status === 'available') {
          const candidates = [front.availableDays, rear.availableDays].filter((v) => typeof v === 'number' && v >= 0);
          return { status: 'available', availableDays: candidates.length ? Math.min(...candidates) : 0 };
        }
        if (front.status === 'available' || rear.status === 'inStock') {
          const candidates = [front.availableDays, rear.availableDays].filter((v) => typeof v === 'number' && v >= 0);
          return { status: 'available', availableDays: candidates.length ? Math.min(...candidates) : 0 };
        }
        return { status: 'outOfStock', availableDays: null };
      });

      const updatePromoTotals = () => {
        discountPrice.value = false;
        productDiscount.value = 0;
        if (!promoType) return;

        const qty = Number(quantity.value) || 0;
        if (qty < 4) return;
        const unitPrice = Number(prodPrice);
        const promoSets = Math.floor(qty / 4);
        if (promoSets <= 0) return;

        if (promoType === 'Buy 3 Get 4' || promoType === 'Buy 3 Get 1') {
          const promoUnit = (unitPrice * 3 + 25) / 4;
          discountPrice.value = promoUnit;
          productDiscount.value = (unitPrice - promoUnit) * 4 * promoSets;
        } else if (promoType === 'Percentage') {
          const promoUnit = unitPrice * ((100 - Number(promoValue)) / 100);
          discountPrice.value = promoUnit;
          productDiscount.value = (unitPrice - promoUnit) * 4 * promoSets;
        } else if (promoType === 'Cash Back') {
          const promoUnit = unitPrice - Number(promoValue) / 4;
          discountPrice.value = promoUnit;
          productDiscount.value = Number(promoValue) * promoSets;
        }
      };

      const normalizeLocationId = (id) =>
        (id || '').toString().replace('gid://shopify/Location/', '').replace(/\D/g, '');

      const normalizeProductId = (id) =>
        (id || '').toString().replace('gid://shopify/Product/', '').replace(/\D/g, '');

      const getEntryProductId = (entry) =>
        normalizeProductId(entry?.productGid || entry?.productId || entry?.id || entry?.node?.id || '');

      const findProductStockEntry = (stockData, productId) => {
        if (!Array.isArray(stockData) || !productId) return null;
        const target = normalizeProductId(productId);
        return stockData.find((item) => getEntryProductId(item) === target) || null;
      };

      const getStockLocations = (entry) => {
        if (!entry) return [];
        if (Array.isArray(entry.locations)) return entry.locations;
        if (Array.isArray(entry.locationStocks)) return entry.locationStocks;
        if (Array.isArray(entry.stockByLocation)) return entry.stockByLocation;
        return [];
      };

      const getLocationIdFromStock = (locationStock) =>
        normalizeLocationId(
          locationStock?.locationGid ||
          locationStock?.locationId ||
          locationStock?.id ||
          locationStock?.location?.id ||
          ''
        );

      const findLocationStock = (locations, locationId) => {
        if (!Array.isArray(locations) || !locationId) return null;
        const target = normalizeLocationId(locationId);
        return locations.find((loc) => getLocationIdFromStock(loc) === target) || null;
      };

      const parseAvailableDays = (locationStock) => {
        const raw = locationStock?.availableDays;
        if (raw === null || raw === undefined || raw === '') return null;
        const parsed = Number(raw);
        return Number.isFinite(parsed) ? parsed : null;
      };

      const getRawAvailability = (locationStock) => {
        const raw = locationStock?.available;
        if (typeof raw === 'string') return raw.trim().toUpperCase();
        if (raw === true) return 'Y';
        if (raw === false) return 'N';
        return null;
      };

      const isLocationAvailable = (locationStock) => {
        const normalized = getRawAvailability(locationStock);
        if (normalized === 'Y' || normalized === 'TRUE' || normalized === 'L') return true;
        if (normalized === 'N' || normalized === 'FALSE') return false;
        return !!locationStock?.available;
      };

      const calculateStockStatus = (locationStock) => {
        if (!locationStock || !isLocationAvailable(locationStock)) {
          return {
            status: 'outOfStock',
            available: false,
            availableDays: parseAvailableDays(locationStock),
            availableDate: locationStock?.availableDate || null,
          };
        }
        const availableDays = parseAvailableDays(locationStock);
        if (getRawAvailability(locationStock) === 'L') {
          return { status: 'limited', available: true, availableDays, availableDate: locationStock.availableDate || null };
        }
        if (availableDays === 0) {
          return { status: 'inStock', available: true, availableDays: 0, availableDate: locationStock.availableDate };
        }
        if (typeof availableDays === 'number' && availableDays > 0) {
          return {
            status: 'available',
            available: true,
            availableDays,
            availableDate: locationStock.availableDate,
          };
        }
        return {
          status: 'inStock',
          available: true,
          availableDays: 0,
          availableDate: locationStock.availableDate || null,
        };
      };

      const findAlternativeStore = (currentStoreId, storesData, stockData, requestedQty) => {
        if (!storesData || !stockData) return null;
        const productStock = findProductStockEntry(stockData, productIdNumber);
        if (!productStock) return null;
        const productLocations = getStockLocations(productStock);
        if (!productLocations.length) return null;

        const currentLoc = findLocationStock(productLocations, currentStoreId);
        const currentAvailDays = currentLoc?.availableDays ?? 999;

        return (
          storesData
            .filter((edge) => {
              const store = edge.node || edge;
              const locId = normalizeLocationId(store.id);
              const distance = parseFloat(edge.distance || '0');
              if (locId === currentStoreId || distance > 150) return false;
              const locStock = findLocationStock(productLocations, locId);
              const locDays = parseAvailableDays(locStock);
              return isLocationAvailable(locStock, requestedQty) && typeof locDays === 'number' && locDays < currentAvailDays;
            })
            .map((edge) => {
              const store = edge.node || edge;
              const locId = normalizeLocationId(store.id);
              const locStock = findLocationStock(productLocations, locId);
              const locDays = parseAvailableDays(locStock);
              return {
                locationId: locId,
                name: store.name,
                distance: edge.distance || '0.0',
                available: isLocationAvailable(locStock, requestedQty),
                availableDays: locDays || 0,
                availableDate: locStock.availableDate,
                stockStatus: locDays === 0 ? 'inStock' : 'available',
                isClosed: store.isClosed,
                closedTo: store.closedTo,
              };
            })
            .sort((a, b) =>
              a.availableDays !== b.availableDays
                ? a.availableDays - b.availableDays
                : parseFloat(a.distance) - parseFloat(b.distance)
            )[0] || null
        );
      };

      // ─── Location IDs helper ───────────────────────────────────────────────
      const getLocationIdsForRequest = (primaryLocationId) => {
        const ids = [normalizeLocationId(primaryLocationId)].filter(Boolean);
        try {
          const raw = localStorage.getItem('storesUnder100');
          if (raw) {
            JSON.parse(raw).forEach((edge) => {
              const store = edge.node || edge;
              const id = normalizeLocationId(store.id);
              if (!ids.includes(id) && parseFloat(edge.distance || '0') <= 150) ids.push(id);
            });
          }
        } catch (e) { }
        return ids;
      };

      // ─── applyStockData ────────────────────────────────────────────────────
      const applyStockData = (stockData, requestedQty = parseInt(quantity.value, 10) || 1) => {
        const productStock = findProductStockEntry(stockData, productIdNumber);

        if (!productStock || !selectedStore.value) {
          stockStatus.value = { status: 'outOfStock', available: false, availableDays: null, availableDate: null };
          alternativeStore.value = null;
          return;
        }

        const locationStock = findLocationStock(getStockLocations(productStock), selectedStore.value.locationId);

        stockStatus.value = locationStock
          ? calculateStockStatus(locationStock)
          : { status: 'outOfStock', available: false, availableDays: null, availableDate: null };

        let storesData = null;
        try {
          const raw = localStorage.getItem('storesUnder100');
          if (raw) storesData = JSON.parse(raw);
        } catch (e) {
          localStorage.removeItem('storesUnder100');
          storeSelector.refreshStoresUnder100();
        }

        alternativeStore.value = findAlternativeStore(
          selectedStore.value.locationId,
          storesData,
          stockData,
          requestedQty
        );
      };

      const toPositiveInt = (value, fallback = null) => {
        const parsed = parseInt(value, 10);
        if (Number.isFinite(parsed) && parsed > 0) return parsed;
        return fallback;
      };

      // ─── requestPdpStock — uses stockStore from pinia.js ──────────────────
      const requestPdpStock = async () => {
        const ss = stockStoreRef.value;
        if (!ss || !selectedStore.value) {
          stockLoading.value = false;
          return;
        }

        stockStatus.value = { status: 'loading', available: false, availableDays: null, availableDate: null };
        alternativeStore.value = null;
        stockLoading.value = true;

        const locationIds = getLocationIdsForRequest(selectedStore.value.locationId);
        if (!locationIds.length) {
          stockLoading.value = false;
          return;
        }

        try {
          const frontRequestedQty = isSplitFitment.value
            ? toPositiveInt(frontQty.value, 1)
            : toPositiveInt(quantity.value, null);
          if (!frontRequestedQty) {
            stockLoading.value = false;
            return;
          }
          const stockData = await ss.requestStock([productIdNumber], locationIds, frontRequestedQty);
          if (ss.PDPStock && 'value' in ss.PDPStock) ss.PDPStock.value = stockData;
          else ss.PDPStock = stockData;

          const requestedFrontQty = frontRequestedQty;
          applyStockData(stockData, Number.isFinite(requestedFrontQty) && requestedFrontQty > 0 ? requestedFrontQty : 1);

          if (rearProduct.value && isSplitFitment.value) {
            if (rearStockStatus.value.status === 'outOfStock' || rearQty.value <= 0) {
              // Don't fetch — but ensure status is settled (not stuck on 'loading')
              if (rearStockStatus.value.status === 'loading') {
                rearStockStatus.value = { status: 'outOfStock', available: false, availableDays: null, availableDate: null };
              }
            } else {
              try {
                const rearRequestedQty = toPositiveInt(rearQty.value, null);
                if (!rearRequestedQty) {
                  stockLoading.value = false;
                  return;
                }
                const rearData = await ss.requestStock([rearProduct.value.id], locationIds, rearRequestedQty);
                const rearProdStock = Array.isArray(rearData)
                  ? findProductStockEntry(rearData, rearProduct.value.id)
                  : null;
                const rearLocStock = findLocationStock(getStockLocations(rearProdStock), selectedStore.value.locationId);
                rearStockStatus.value = rearLocStock
                  ? calculateStockStatus(rearLocStock)
                  : { status: 'outOfStock', available: false, availableDays: null, availableDate: null };
              } catch (e) {
                console.error('Error fetching rear stock:', e);
                rearStockStatus.value = { status: 'outOfStock', available: false, availableDays: null, availableDate: null };
              }
            }
          }
        } catch (e) {
          stockStatus.value = { status: 'outOfStock', available: false, availableDays: null, availableDate: null };
          alternativeStore.value = null;
        } finally {
          stockLoading.value = false;
        }
      };



      const fetchRearProductFallback = async () => {
        if (!isSplitFitment.value) {
          rearProduct.value = null;
          return;
        }

        const matches = Array.isArray(splitFitment.value.rearMatches) ? splitFitment.value.rearMatches : [];
        const normalized = matches.map(normalizeMatch).filter(Boolean);
        if (!normalized.length) return;

        const collectionHandle = shopifyConfig?.tyresCollection || shopifyConfig?.wheelsCollection || '';
        if (!collectionHandle) return;

        const getProductTag = (tags) => {
          const idx = tags.findIndex(tag => tag.includes('product:') || tag.includes('Product:'))
          return idx > -1 ? tags[idx] : null;
        };
        const productTag = getProductTag(prodTags);
        if (!productTag) return;

        for (const matchValue of normalized) {
          let metaCall = '';
          if (prodType?.includes('yre') || prodType?.includes('ire')) {
            metaCall = `width: metafield(namespace:"wheel_tyre_spec",key:"width") { value }
            aspectRatio: metafield(namespace:"tyre_spec",key:"aspect_ratio") { value }
            rimDiameter: metafield(namespace:"wheel_tyre_spec",key:"rim_diameter") { value }
            loadIndex: metafield(namespace:"tyre_spec",key:"load_index") { value }
            speedRating: metafield(namespace:"tyre_spec",key:"speed_rating") { value }`
          } else if (prodType?.includes('heel')) {
            metaCall = `rimDiameter: metafield(namespace:"wheel_tyre_spec",key:"rim_diameter") { value }
            width: metafield(namespace:"wheel_tyre_spec",key:"width") { value }
            bolt: metafield(namespace:"wheel_spec",key:"bolt") { value }
            pcd: metafield(namespace:"wheel_spec",key:"pcd") { value }
            loadRating: metafield(namespace:"wheel_spec",key:"load_rating_kg") { value }
            centreBore: metafield(namespace:"wheel_spec",key:"centre_bore") { value }
            offset: metafield(namespace:"wheel_spec",key:"offset") { value }`
          }
          const query = `{
              collection(handle:"${collectionHandle}") {
                products(first:24, filters:[
                  {productMetafield:{namespace:"wts",key:"sf",value:"${matchValue}"}},
                  {tag:"${productTag}"}
                ]) {
                  edges {
                    node {
                      id title handle vendor
                      featuredImage { url }
                      priceRange { minVariantPrice { amount } }
                      variants(first:1) { edges { node { id sku } } }
                      collections(first:50) {
                        edges {
                          node {
                            promoType: metafield(namespace:"promotion",key:"type") { value }
                            promoValue: metafield(namespace:"promotion",key:"value") { value }
                          }
                        }
                      }
                      ${metaCall}
                    }
                  }
                }
              }
            }`;

          try {
            const response = await fetch(`${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP,
              },
              body: JSON.stringify({ query }),
            });
            if (!response.ok) continue;

            const data = await response.json();
            const edges = data?.data?.collection?.products?.edges || [];
            const productNode = edges
              .map((edge) => edge?.node)
              .find((node) => node && node.id !== `gid://shopify/Product/${productIdNumber}`);
            if (!productNode) continue;

            const rearPromoEdge = (productNode.collections?.edges || []).find(e => e?.node?.promoType?.value);
            const rearPromoType = rearPromoEdge?.node?.promoType?.value || '';
            const rearPromoValue = rearPromoEdge?.node?.promoValue?.value || '0';

            if (prodType?.includes('yre') || prodType?.includes('ire')) {
              rearProduct.value = {
                id: productNode.id.replace('gid://shopify/Product/', ''),
                title: productNode.title,
                handle: productNode.handle,
                vendor: productNode.vendor,
                image: productNode.featuredImage?.url || '',
                price: Number(productNode?.priceRange?.minVariantPrice?.amount),
                variantId: productNode?.variants?.edges?.[0]?.node?.id || '',
                sku: productNode?.variants?.edges?.[0]?.node?.sku || '',
                width: productNode?.width?.value || '',
                aspectRatio: productNode?.aspectRatio?.value || '',
                rimDiameter: productNode?.rimDiameter?.value || '',
                loadIndex: productNode?.loadIndex?.value || '',
                speedRating: productNode?.speedRating?.value || '',
                promoType: rearPromoType,
                promoValue: rearPromoValue,
              };
            } else if (prodType?.includes('heel')) {
              rearProduct.value = {
                id: productNode.id.replace('gid://shopify/Product/', ''),
                title: productNode.title,
                handle: productNode.handle,
                vendor: productNode.vendor,
                image: productNode.featuredImage?.url || '',
                price: Number(productNode?.priceRange?.minVariantPrice?.amount),
                variantId: productNode?.variants?.edges?.[0]?.node?.id || '',
                sku: productNode?.variants?.edges?.[0]?.node?.sku || '',
                rimDiameter: productNode?.rimDiameter?.value || '',
                width: productNode?.width?.value || '',
                bolt: productNode?.bolt?.value || '',
                pcd: productNode?.pcd?.value || '',
                loadRating: productNode?.loadRating?.value || '',
                centreBore: productNode?.centreBore?.value || '',
                offset: productNode?.offset?.value || '',
                promoType: rearPromoType,
                promoValue: rearPromoValue,
              };
            }
            return;
          } catch (e) {
            console.error('Error fetching rear match:', matchValue, e);
          }
        }
      };

      const fetchRearProduct = async () => {
        if (!isSplitFitment.value) {
          rearProduct.value = null
          frontUnavailable.value = false
          return
        }

        const params = new URLSearchParams(window.location.search)
        const frontHandleParam = params.get('f')
        const rearHandleParam = params.get('r') || params.get('rp')
        const rearId = params.get('rearId')
        const frontId = params.get('frontId')
        const onlyRear = params.get('onlyRear') === 'true'

        const mapNodeToPdpProduct = (node) => {
          if (!node) return null
          const promoEdge = (node.collections?.edges || []).find(e => e?.node?.promoType?.value)
          const nodePromoType = promoEdge?.node?.promoType?.value || ''
          const nodePromoValue = promoEdge?.node?.promoValue?.value || '0'

          if (prodType?.includes('yre') || prodType?.includes('ire')) {
            return {
              id: node.id.replace('gid://shopify/Product/', ''),
              title: node.title,
              handle: node.handle,
              vendor: node.vendor,
              image: node.featuredImage?.url || '',
              price: Number(node.priceRange?.minVariantPrice?.amount),
              variantId: node.variants?.edges?.[0]?.node?.id || '',
              sku: node.variants?.edges?.[0]?.node?.sku || '',
              width: node.width?.value || '',
              aspectRatio: node.aspectRatio?.value || '',
              rimDiameter: node.rimDiameter?.value || '',
              loadIndex: node.loadIndex?.value || '',
              speedRating: node.speedRating?.value || '',
              promoType: nodePromoType,
              promoValue: nodePromoValue,
            }
          }

          if (prodType?.includes('heel')) {
            return {
              id: node.id.replace('gid://shopify/Product/', ''),
              title: node.title,
              handle: node.handle,
              vendor: node.vendor,
              image: node.featuredImage?.url || '',
              price: Number(node.priceRange?.minVariantPrice?.amount),
              variantId: node.variants?.edges?.[0]?.node?.id || '',
              sku: node.variants?.edges?.[0]?.node?.sku || '',
              rimDiameter: node.rimDiameter?.value || '',
              width: node.width?.value || '',
              bolt: node.bolt?.value || '',
              pcd: node.pcd?.value || '',
              loadRating: node.loadRating?.value || '',
              centreBore: node.centreBore?.value || '',
              offset: node.offset?.value || '',
              promoType: nodePromoType,
              promoValue: nodePromoValue,
            }
          }

          return null
        }

        const fetchRearByHandle = async (handle) => {
          const safeHandle = String(handle || '').trim()
          if (!safeHandle || safeHandle.toLowerCase() === 'none') return null

          let metaCall = ''
          if (prodType?.includes('yre') || prodType?.includes('ire')) {
            metaCall = `
              width: metafield(namespace:"wheel_tyre_spec", key:"width") { value }
              aspectRatio: metafield(namespace:"tyre_spec", key:"aspect_ratio") { value }
              rimDiameter: metafield(namespace:"wheel_tyre_spec", key:"rim_diameter") { value }
              loadIndex: metafield(namespace:"tyre_spec", key:"load_index") { value }
              speedRating: metafield(namespace:"tyre_spec", key:"speed_rating") { value }
            `
          } else if (prodType?.includes('heel')) {
            metaCall = `
              rimDiameter: metafield(namespace:"wheel_tyre_spec", key:"rim_diameter") { value }
              width: metafield(namespace:"wheel_tyre_spec", key:"width") { value }
              bolt: metafield(namespace:"wheel_spec", key:"bolt") { value }
              pcd: metafield(namespace:"wheel_spec", key:"pcd") { value }
              loadRating: metafield(namespace:"wheel_spec", key:"load_rating_kg") { value }
              centreBore: metafield(namespace:"wheel_spec", key:"centre_bore") { value }
              offset: metafield(namespace:"wheel_spec", key:"offset") { value }
            `
          }

          const escapedHandle = safeHandle.replace(/\\/g, '\\\\').replace(/"/g, '\\"')
          const query = `{
            productByHandle(handle: "${escapedHandle}") {
              id title handle vendor
              featuredImage { url }
              priceRange { minVariantPrice { amount } }
              variants(first:1) { edges { node { id sku } } }
              collections(first:50) {
                edges {
                  node {
                    promoType: metafield(namespace:"promotion", key:"type") { value }
                    promoValue: metafield(namespace:"promotion", key:"value") { value }
                  }
                }
              }
              ${metaCall}
            }
          }`

          const response = await fetch(
            `${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP,
              },
              body: JSON.stringify({ query }),
            }
          )
          if (!response.ok) return null
          const data = await response.json()
          return mapNodeToPdpProduct(data?.data?.productByHandle || null)
        }

        // New PLP URL contract:
        // - both present: ?f=<front_handle>&r=<rear_handle>
        // - rear only: ?r=<rear_handle>
        if (frontHandleParam || rearHandleParam) {
          const frontHandle = String(frontHandleParam || '').trim().toLowerCase()
          const rearHandle = String(rearHandleParam || '').trim()

          // If front is omitted but rear is provided, treat as rear-only entry.
          if ((!frontHandle && rearHandle) || frontHandle === 'none') {
            frontUnavailable.value = true
            frontQty.value = 0;
          } else {
            frontUnavailable.value = false
          }

          if (!rearHandle || rearHandle.toLowerCase() === 'none') {
            rearProduct.value = null
            return
          }

          try {
            const rearNode = await fetchRearByHandle(rearHandle)
            if (rearNode) {
              rearProduct.value = rearNode
              return
            }
          } catch (e) {
            console.error('Error fetching rear product by handle:', e)
          }

          return fetchRearProductFallback()
        }

        // Current page is the rear product — front doesn't exist in collection
        if (onlyRear) {
          // Front doesn't exist — treat as normal single product, no split UI
          rearProduct.value = null
          frontUnavailable.value = false
          return
        }

        // Came from PLP split card with frontId but no rearId — rear not in collection
        if (frontId && !rearId) {
          rearProduct.value = null
          frontUnavailable.value = false
          return
        }

        // No params — direct URL visit, use fallback collection query
        if (!frontId && !rearId) {
          frontUnavailable.value = false
          return fetchRearProductFallback()
        }

        // Has rearId — fetch rear product directly by ID
        frontUnavailable.value = false

        let metaCall = ''
        if (prodType?.includes('yre') || prodType?.includes('ire')) {
          metaCall = `
            width: metafield(namespace:"wheel_tyre_spec", key:"width") { value }
            aspectRatio: metafield(namespace:"tyre_spec", key:"aspect_ratio") { value }
            rimDiameter: metafield(namespace:"wheel_tyre_spec", key:"rim_diameter") { value }
            loadIndex: metafield(namespace:"tyre_spec", key:"load_index") { value }
            speedRating: metafield(namespace:"tyre_spec", key:"speed_rating") { value }
        `
        } else if (prodType?.includes('heel')) {
          metaCall = `
            rimDiameter: metafield(namespace:"wheel_tyre_spec", key:"rim_diameter") { value }
            width: metafield(namespace:"wheel_tyre_spec", key:"width") { value }
            bolt: metafield(namespace:"wheel_spec", key:"bolt") { value }
            pcd: metafield(namespace:"wheel_spec", key:"pcd") { value }
            loadRating: metafield(namespace:"wheel_spec", key:"load_rating_kg") { value }
            centreBore: metafield(namespace:"wheel_spec", key:"centre_bore") { value }
            offset: metafield(namespace:"wheel_spec", key:"offset") { value }
        `
        }

        const query = `{
        product(id: "gid://shopify/Product/${rearId}") {
            id title handle vendor
            featuredImage { url }
            priceRange { minVariantPrice { amount } }
            variants(first:1) { edges { node { id sku } } }
            collections(first:50) {
                edges {
                    node {
                        promoType: metafield(namespace:"promotion", key:"type") { value }
                        promoValue: metafield(namespace:"promotion", key:"value") { value }
                    }
                }
            }
            ${metaCall}
        }
    }`

        try {
          const response = await fetch(
            `${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP,
              },
              body: JSON.stringify({ query }),
            }
          )

          if (!response.ok) return fetchRearProductFallback()

          const data = await response.json()
          const node = data?.data?.product
          if (!node) return fetchRearProductFallback()

          rearProduct.value = mapNodeToPdpProduct(node)

        } catch (e) {
          console.error('Error fetching rear product by ID:', e)
          return fetchRearProductFallback()
        }
      }

      const resolveStoreDistance = (storeId, explicitDistance) => {
        const normalizedId = normalizeLocationId(storeId);
        const toDistanceString = (value) => {
          if (value === null || value === undefined || value === '') return null;
          const parsed = Number(value);
          if (Number.isFinite(parsed)) return parsed.toFixed(2);
          return String(value);
        };

        const explicit = toDistanceString(explicitDistance);
        if (explicit !== null) return explicit;

        let storeList = storeSelectorRef.value?.storeList;
        if (storeList && 'value' in storeList) storeList = storeList.value;
        if (Array.isArray(storeList)) {
          const matched = storeList.find((edge) =>
            normalizeLocationId(edge?.node?.id || edge?.id) === normalizedId
          );
          const listDistance = toDistanceString(matched?.distance);
          if (listDistance !== null) return listDistance;
        }

        try {
          const nearRaw = localStorage.getItem('storesUnder100');
          const nearStores = nearRaw ? JSON.parse(nearRaw) : [];
          if (Array.isArray(nearStores)) {
            const matchedNear = nearStores.find((edge) =>
              normalizeLocationId(edge?.node?.id || edge?.id) === normalizedId
            );
            const nearDistance = toDistanceString(matchedNear?.distance);
            if (nearDistance !== null) return nearDistance;
          }
        } catch (e) { }

        try {
          const currentRaw = localStorage.getItem('currentNearestStore');
          const currentStore = currentRaw ? JSON.parse(currentRaw) : null;
          if (
            normalizeLocationId(currentStore?.node?.id || currentStore?.id) === normalizedId
          ) {
            const currentDistance = toDistanceString(currentStore?.distance);
            if (currentDistance !== null) return currentDistance;
          }
        } catch (e) { }

        return '0.0';
      };

      const getSelectedStoreFromSelector = () => {
        const ss = storeSelectorRef.value;
        const nearestStore = ss?.nearestStore || null;
        const store = nearestStore?.node || nearestStore || null;
        if (!store?.id) return null;
        return {
          locationId: normalizeLocationId(store.id),
          name: store.name,
          distance: resolveStoreDistance(store.id, nearestStore?.distance || store?.distance),
          isClosed: store.isClosed,
          closedTo: store.closedTo,
        };
      };

      // switchToStore — same pattern as collection.js storeSelect / switchToStore
      const switchToStore = (newStoreId) => {
        const storeSelector = window.storeSelector();

        const normalizeId = (id) => (id || '').toString().replace('gid://shopify/Location/', '');
        const targetId = normalizeId(newStoreId);

        let storeList = storeSelector.storeList;
        if (storeList && 'value' in storeList) storeList = storeList.value;

        const targetIndex = Array.isArray(storeList)
          ? storeList.findIndex((edge) => normalizeId(edge?.node?.id || edge?.id) === targetId)
          : -1;

        if (targetIndex > -1) {
          alternativeStore.value = null;
          stockStatus.value = { status: 'loading', available: false, availableDays: null, availableDate: null };
          storeSelector.storeSelect(targetIndex); // pinia.js storeSelect persists to localStorage
          setTimeout(handleStoreChange, 500);
          return;
        }

        // Fallback: read from localStorage (same pattern as collection.js)
        try {
          const raw = localStorage.getItem('storesUnder100');
          const stores = raw ? JSON.parse(raw) : [];
          const fallback = stores.find((edge) => normalizeId(edge?.node?.id || edge?.id) === targetId) || null;
          if (fallback) {
            storeSelector.updateNearestStore(fallback);
            localStorage.setItem('currentNearestStore', JSON.stringify(fallback));
            window.collectionStore().clearCache();
            selectedStore.value = {
              locationId: normalizeLocationId(fallback.node.id),
              name: fallback.node.name,
              distance: resolveStoreDistance(fallback.node.id, fallback.distance),
              isClosed: fallback.node.isClosed,
              closedTo: fallback.node.closedTo,
            };
            alternativeStore.value = null;
            if (isServiceProduct) {
              serviceStockCheck()
            } else {
              requestPdpStock();
            }
          }
        } catch (e) { }
      };

      const handleStoreChange = () => {
        selectedStore.value = getSelectedStoreFromSelector();
        if (selectedStore.value) {
          stockStatus.value = { status: 'loading', available: false, availableDays: null, availableDate: null };
          if (rearStockStatus.value.status !== 'outOfStock') {
            rearStockStatus.value = { status: 'loading', available: false, availableDays: null, availableDate: null };
          }
          alternativeStore.value = null;
          if (isServiceProduct) {
            serviceStockCheck()
          } else {
            requestPdpStock();
          }
        } else {
          stockLoading.value = false;
          stockStatus.value = { status: 'outOfStock', available: false, availableDays: null, availableDate: null };
          alternativeStore.value = null;
        }
      };

      const updateSplitQty = (side, delta) => {
        if (side === 'front') {
          frontQty.value = Math.max(0, frontQty.value + delta);
        } else {
          rearQty.value = Math.max(0, rearQty.value + delta);
        }
      };

      const buyItNow = () => {
        if (!isPurchasableStatus(stockStatus.value.status)) return;
        showBuyNowModal.value = true;
      };

      const hideModal = () => {
        showBuyNowModal.value = false;
        showDiscountModal.value = false;
      };

      const isImageZoomOpen = Vue.ref(false);
      const zoomImageSrc = Vue.ref('');
      const zoomImageAlt = Vue.ref('');
      const imageZoomOverlayRef = Vue.ref(null);

      const openImageZoom = (imgEl) => {
        if (!imgEl) return;
        zoomImageSrc.value = imgEl.getAttribute('data-zoom-src') || imgEl.getAttribute('src') || '';
        zoomImageAlt.value = imgEl.getAttribute('alt') || '';
        isImageZoomOpen.value = true;
        Vue.nextTick(() => imageZoomOverlayRef.value?.focus());
      };

      const closeImageZoom = () => {
        isImageZoomOpen.value = false;
      };

      Vue.watch(isImageZoomOpen, (isOpen) => {
        document.body.style.overflow = isOpen ? 'hidden' : '';
      });

      const getVariantId = (id) => {
        if (!id) return null;
        return id.toString().replace('gid://shopify/ProductVariant/', '');
      };

      const getCartId = (cartToolsInstance) => {
        if (!cartToolsInstance) return null;
        const cartData = cartToolsInstance.cartData?.value || cartToolsInstance.cartData || null;
        if (cartData?.id) return cartData.id;
        try {
          const raw = localStorage.getItem('cartData');
          if (!raw) return null;
          const parsed = JSON.parse(raw);
          return parsed?.id || null;
        } catch (e) {
          return null;
        }
      };

      const isBuy3Get4Promo = (type) => {
        const normalized = String(type || '').trim().toLowerCase();
        return normalized === 'buy 3 get 4' || normalized === 'buy 3 get 1';
      };

      const addVariantToCart = async (variantId, qty, promo = false) => {
        const cartTools = window.cartTools();
        if (!variantId || !qty) return;
        const safeQty = parseInt(qty, 10) || 1;
        const cartId = getCartId(cartTools);
        if (cartId) {
          await cartTools.cartAdd(variantId, safeQty, cartId, promo);
          return;
        }
        const vehicleSearch = window.vehicleSearch();
        const storeSelector = window.storeSelector();
        const location = storeSelector.location?.value || storeSelector.location || false;
        await cartTools.newCart(variantId, safeQty, vehicleSearch?.vehicles, location, promo);
      };

      const exemptionCheck = async (handle) => {
        const globalTools = window.globalTools();
        const queryString = `{
	              product(handle:"${handle}") {
		              collections(first:100) {
			              edges {
				              node {
					              id
				              }
			              }
		              }
	              }
              }`;
        const respObj = await globalTools.genericQuery(queryString);
        if (respObj.data.product.collections.edges.findIndex(edge => edge.node.id === `gid://shopify/Collection/${shopifyConfig.fitmentFeeExemptionCollection}`) === -1) return false;
        return true;
      }

      const addToCart = async (source) => {
        const isSplitSource = source === 'split' && isSplitFitment.value;
        if (isSplitSource) {
          if (!isPurchasableStatus(stockStatus.value.status) && !isPurchasableStatus(rearStockStatus.value.status)) return;
        } else if (!isPurchasableStatus(stockStatus.value.status)) {
          return;
        }
        const stateRef = isSplitSource ? splitCartState : mainCartState;
        if (stateRef.value === 'adding') return;
        stateRef.value = 'adding';

        try {
          if (source === 'split' && isSplitFitment.value) {
            const fQty = Number(effectiveFrontQty.value) || 0;
            const rQty = Number(effectiveRearQty.value) || 0;
            const frontVariantId = getVariantId(prodVariantId);
            const rearVariantId = getVariantId(rearProduct.value?.variantId);
            let frontPromo = isBuy3Get4Promo(promoType);
            if (frontPromo && prodHandle) {
              const frontExempt = await exemptionCheck(prodHandle);
              if (frontExempt) frontPromo = false;
            }
            let rearPromo = isBuy3Get4Promo(rearProduct.value?.promoType);
            if (rearPromo && rearProduct?.value?.handle) {
              const rearExempt = await exemptionCheck(rearProduct.value.handle);
              if (rearExempt) rearPromo = false;
            }
            if (frontVariantId && fQty > 0) {
              await addVariantToCart(frontVariantId, fQty, frontPromo);
            }
            if (rearVariantId && rQty > 0) {
              await addVariantToCart(rearVariantId, rQty, rearPromo);
            }
          } else {
            const qty = parseInt(quantity.value, 10) || 1;
            const variantId = getVariantId(prodVariantId);
            let mainPromo = isBuy3Get4Promo(promoType);
            if (mainPromo && prodHandle) {
              const isExempt = await exemptionCheck(prodHandle);
              if (isExempt) mainPromo = false;
            }
            if (variantId && qty > 0) {
              await addVariantToCart(variantId, qty, mainPromo);
            }
          }
          stateRef.value = 'added';
          setTimeout(() => {
            stateRef.value = 'idle';
          }, 1300);
        } catch (e) {
          stateRef.value = 'idle';
        }
      };

      const sendEnquiry = (title, sku, splitTitle, splitSku) => {
        if (splitTitle && splitSku) {
          localStorage.setItem('storeEnquiry', JSON.stringify(
            {
              title: title,
              sku: sku,
              splitTitle: splitTitle,
              splitSku: splitSku
            }
          ))
        } else {
          localStorage.setItem('storeEnquiry', JSON.stringify(
            {
              title: title,
              sku: sku
            }
          ))
        }

        if (!productIdNumber) return;
        const existingIndex = compareStore?.selectedProducts.findIndex(
          (p) => normalizeCompareProductId(p.id || p.node?.id) === productIdNumber
        );
        if (existingIndex === -1) {

          if (compareStore.selectedProducts.length >= 3) {
            compareStore.selectedProducts.splice(0, 1);
          }

          compareStore.selectedProducts.push({
            id: productIdNumber,
            title: prodTitle,
            price: Number(prodPrice),
            featured_image: prodImage,
            vendor: prodVendor,
            available: true,
          });
          compareStore.persist();
        }
        window.location.href = `${shopifyConfig.storeURL}/pages/${shopifyConfig.contactDefault}`;
      };


      Vue.watch(quantity, (newQty) => {
        updatePromoTotals();
        const normalizedQty = toPositiveInt(newQty, null);
        if (!normalizedQty) return;

        if (isSplitFitment.value || !selectedStore.value || stockLoading.value) return;

        const ss = stockStoreRef.value;

        if (!ss?.PDPStock) return;

        const stockData = ss.PDPStock.value || ss.PDPStock;

        const productStock = findProductStockEntry(stockData, productIdNumber);

        if (!productStock) {
          stockStatus.value = { status: 'outOfStock', available: false, availableDays: null, availableDate: null };

          return;
        }

        const locStock = findLocationStock(getStockLocations(productStock), selectedStore.value.locationId);

        if (locStock) {
          stockStatus.value = calculateStockStatus(locStock);

          let storesData = null;

          try {
            const raw = localStorage.getItem('storesUnder100');

            if (raw) storesData = JSON.parse(raw);
          } catch (e) {
            localStorage.removeItem('storesUnder100');
            storeSelector.refreshStoresUnder100();
          }


          alternativeStore.value = findAlternativeStore(
            selectedStore.value.locationId,

            storesData,

            stockData,
            normalizedQty
          );
        } else {
          stockStatus.value = { status: 'outOfStock', available: false, availableDays: null, availableDate: null };
        }

        if (selectedStore.value) {
          if (isServiceProduct) {
            serviceStockCheck()
          } else {
            requestPdpStock();
          }
        }
      });


      Vue.watch(frontQty, async (newQty) => {
        if (!isSplitFitment.value || !selectedStore.value) return;
        if (newQty <= 0) return;
        const qty = Number(newQty);
        if (!Number.isFinite(qty) || qty <= 0) return;

        const ss = stockStoreRef.value;
        if (!ss) return;
        const locationIds = getLocationIdsForRequest(selectedStore.value.locationId);
        try {
          stockLoading.value = true;
          if (stockStatus.value.status !== 'outOfStock')
            stockStatus.value = { status: 'loading', available: false, availableDays: null, availableDate: null };

          const stockData = await ss.requestStock([productIdNumber], locationIds, qty);
          if (ss.PDPStock && 'value' in ss.PDPStock) ss.PDPStock.value = stockData;
          else ss.PDPStock = stockData;
          applyStockData(stockData, qty);

          if (rearProduct.value && rearStockStatus.value.status !== 'outOfStock' && rearQty.value > 0) {
            const rq = Number(rearQty.value);
            if (!Number.isFinite(rq) || rq <= 0) return;
            const rearData = await ss.requestStock([rearProduct.value.id], locationIds, rq);
            const rps = Array.isArray(rearData)
              ? findProductStockEntry(rearData, rearProduct.value.id)
              : null;
            rearStockStatus.value = rps
              ? calculateStockStatus(findLocationStock(getStockLocations(rps), selectedStore.value.locationId))
              : { status: 'outOfStock', available: false, availableDays: null, availableDate: null };
          }
        } catch (e) {
          console.error('Error fetching front stock:', e);
        } finally {
          stockLoading.value = false;
        }
      });

      Vue.watch(rearQty, async (newQty) => {
        if (!isSplitFitment.value || !rearProduct.value || !selectedStore.value) return;
        const qty = Number(newQty);
        if (!Number.isFinite(qty) || qty <= 0) return;

        const ss = stockStoreRef.value;
        if (!ss) return;
        const locationIds = getLocationIdsForRequest(selectedStore.value.locationId);
        try {
          stockLoading.value = true;
          rearStockStatus.value = { status: 'loading', available: false, availableDays: null, availableDate: null };

          const rearData = await ss.requestStock([rearProduct.value.id], locationIds, qty);
          const rps = Array.isArray(rearData)
            ? findProductStockEntry(rearData, rearProduct.value.id)
            : null;
          rearStockStatus.value = rps
            ? calculateStockStatus(findLocationStock(getStockLocations(rps), selectedStore.value.locationId))
            : { status: 'outOfStock', available: false, availableDays: null, availableDate: null };

          if (stockStatus.value.status !== 'outOfStock' && (frontQty.value || 0) > 0) {
            const fq = Number(frontQty.value);
            if (!Number.isFinite(fq) || fq <= 0) return;
            const frontData = await ss.requestStock([productIdNumber], locationIds, fq);
            if (ss.PDPStock && 'value' in ss.PDPStock) ss.PDPStock.value = frontData;
            else ss.PDPStock = frontData;
            applyStockData(frontData, fq);
          }
        } catch (e) {
          console.error('Error fetching rear stock:', e);
          rearStockStatus.value = {
            status: 'outOfStock',
            available: false,
            availableDays: null,
            availableDate: null,
          };
        } finally {
          stockLoading.value = false;
        }
      });

      Vue.watch(rearProduct, async (newRear) => {
        if (!newRear || !selectedStore.value) {
          rearStockStatus.value = {
            status: 'outOfStock',
            available: false,
            availableDays: null,
            availableDate: null,
          };
          rearQty.value = 0;
          return;
        }
        const ss = stockStoreRef.value;
        if (!ss) return;
        const qtyForRear = parseInt(rearQty.value) || 2;
        const locationIds = getLocationIdsForRequest(selectedStore.value.locationId);
        try {
          const stockData = await ss.requestStock([newRear.id], locationIds, qtyForRear);
          const rps = Array.isArray(stockData) ? findProductStockEntry(stockData, newRear.id) : null;
          rearStockStatus.value = rps
            ? calculateStockStatus(findLocationStock(getStockLocations(rps), selectedStore.value.locationId))
            : { status: 'outOfStock', available: false, availableDays: null, availableDate: null };
          if (rearStockStatus.value.status === 'outOfStock') rearQty.value = 0;
        } catch (e) {
          rearStockStatus.value = {
            status: 'outOfStock',
            available: false,
            availableDays: null,
            availableDate: null,
          };
          rearQty.value = 0;
        }
      });

      Vue.watch(
        () => rearStockStatus.value.status,
        (status) => {
          if (status === 'outOfStock') rearQty.value = 0;
        }
      );

      Vue.watch(
        () => rearStockStatus.value.status,
        (status, prevStatus) => {
          // Only zero qty when transitioning from a real fetch result, not from initial/loading state
          if (status === 'outOfStock' && prevStatus !== 'loading' && prevStatus !== 'outOfStock') {
            rearQty.value = 0;
          }
        }
      );

      Vue.watch(
        () => stockStatus.value.status,
        (status, prevStatus) => {
          if (status === 'outOfStock' && prevStatus !== 'loading' && prevStatus !== 'outOfStock') {
            frontQty.value = 0;
          }
        }
      );

      const faqs = Vue.ref(false);
      const vehicleCategory = Vue.computed(() => vehicleSearch.vehicles?.[0]?.fitmentInfo?.categories?.findIndex(cat => cat?.key === 'fq') > -1 ? vehicleSearch.vehicles?.[0]?.fitmentInfo?.categories?.filter(cat => cat.key === 'fq')[0].value : 'commuter');

      const faqArray = Vue.computed(() => vehicleCategory?.value && faqs?.value ? faqs?.value?.[vehicleCategory.value] : false);

      const getFaqs = async () => {
        if (!faqObject) return
        let queryString = `{
          	metaobject(id:"gid://shopify/Metaobject/${faqObject}") {
		          fields {				
			          key
			          value
		          }		
	          }
          }`

        let faqResponse = await globalTools.genericQuery(queryString);
        if (faqResponse?.data?.metaobject?.fields?.[0]?.value) {
          try {
            let parsedFaq = JSON.parse(faqResponse.data.metaobject.fields[0].value);
            faqs.value = parsedFaq;
          } catch (e) {
            throw new Error(`Unable to fetch FAQs: ${e}`);
          }
        }
      }

      Vue.watch(vehicleCategory, () => {
        getFaqs();
      })

      let floatingCartObserver = null;

      Vue.onMounted(() => {
        const setupFloatingCartObserver = () => {
          const realButton = document.querySelector('#PDP .addToCart, #PDP .splitCartButton');
          if (!realButton) {
            setTimeout(setupFloatingCartObserver, 150);
            return;
          }
          if (floatingCartObserver) floatingCartObserver.disconnect();
          floatingCartObserver = new IntersectionObserver(([entry]) => {
            isPastAddToCart.value = !entry.isIntersecting;
          }, { threshold: 0 });
          floatingCartObserver.observe(realButton);
        };
        setupFloatingCartObserver();

        const setupImageGallery = () => {
          const imageColumn = document.querySelector('#PDP .imageColumn');
          if (!imageColumn || imageColumn.dataset.galleryBound === '1') return;

          const mainImage = imageColumn.querySelector('.mainImageContainer .productImage');
          const counter = imageColumn.querySelector('.mainImageContainer .imageCounter');
          const thumbs = Array.from(imageColumn.querySelectorAll('.imageThumbnails .thumbnailItem'));
          if (!mainImage || !thumbs.length) return;

          const total = Number(counter?.dataset?.total || thumbs.length);
          thumbs.forEach((thumb, idx) => {
            thumb.addEventListener('click', () => {
              const thumbImg = thumb.querySelector('img');
              const nextSrc = thumbImg?.dataset?.mainSrc || thumbImg?.getAttribute('src') || '';
              if (nextSrc) {
                mainImage.setAttribute('src', nextSrc);
                // Shopify image_tag can include srcset/sizes; clear them so clicked src is used.
                mainImage.removeAttribute('srcset');
                mainImage.removeAttribute('sizes');
              }
              const nextAlt = thumbImg?.getAttribute('alt') || '';
              if (nextAlt) mainImage.setAttribute('alt', nextAlt);

              thumbs.forEach((t) => t.classList.remove('active'));
              thumb.classList.add('active');

              if (counter) counter.textContent = `${idx + 1} / ${total}`;
            });
          });

          imageColumn.dataset.galleryBound = '1';
        };

        setupImageGallery();
        updatePromoTotals();

        const initStores = () => {
          storeSelectorRef.value = window.storeSelector();
          stockStoreRef.value = window.stock();

          const initialStoreId =
            storeSelectorRef.value?.nearestStore?.node?.id || storeSelectorRef.value?.nearestStore?.id || null;
          lastStoreId.value = initialStoreId;
          selectedStore.value = getSelectedStoreFromSelector();
          if (selectedStore.value) {
            if (isServiceProduct) {
              serviceStockCheck()
            } else {
              requestPdpStock();
            }
          } else stockLoading.value = false;
        };
        initStores();
        fetchRearProduct();
        fetchPrevCollectionStrip();
        window.addEventListener('resize', centerCurrentStripCard);
        getFaqs();
      });

      const fetchPdpPromoData = async () => {
        const gid = pdpProductGid;
        if (!gid || !shopifyConfig?.PLP) return;
        const query = `{
          product(id: "${gid}") {
            bestDealText: metafield(namespace:"price", key:"best_deal_text") { jsonValue }
            collections(first: 10) {
              edges {
                node {
                  type: metafield(namespace:"promotion", key:"type") { value }
                  end_date: metafield(namespace:"promotion", key:"end_date") { value }
                }
              }
            }
          }
        }`;
        try {
          const res = await fetch(`${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP,
            },
            body: JSON.stringify({ query }),
          });
          const json = await res.json();
          const p = json?.data?.product;
          if (!p) return;
          if (enableBestPriceXMonths) {
            const bdtRaw = p.bestDealText?.jsonValue;
            if (bdtRaw) {
              if (bdtRaw.best_deal_text) pdpBestDealText.value = bdtRaw.best_deal_text;
            }
          }
          const promoEdge = p.collections?.edges?.find(e => e?.node?.type?.value);
          const endRaw = promoEdge?.node?.end_date?.value;
          if (endRaw) {
            pdpPromoEndDate.value = new Date(endRaw).getTime();
          }
        } catch (e) { }
      };

      let storePollId = null;
      let promoTimerId = null;
      Vue.onMounted(() => {
        storePollId = setInterval(() => {
          const currentId =
            storeSelectorRef.value?.nearestStore?.node?.id || storeSelectorRef.value?.nearestStore?.id || null;
          if (currentId && currentId !== lastStoreId.value) {
            lastStoreId.value = currentId;
            handleStoreChange();
          }
        }, 500);

        fetchPdpPromoData().then(() => {
          if (pdpPromoEndDate.value && !promoTimerId) {
            promoTimerId = setInterval(() => { promoStore.currentTime = Date.now(); }, 1000);
          }
        });
      });

      Vue.onBeforeUnmount(() => {
        if (storePollId) clearInterval(storePollId);
        if (promoTimerId) clearInterval(promoTimerId);
        if (floatingCartObserver) floatingCartObserver.disconnect();
        window.removeEventListener('resize', centerCurrentStripCard);
        document.body.style.overflow = '';
      });

      const newProductLayout = Pinia.storeToRefs(pdpNewProductStore);

      return {
        ...newProductLayout,
        quantity,
        discountPrice,
        productDiscount,
        showBuyNowModal,
        showDiscountModal,
        showDiscountFade,
        stockLoading,
        selectedStore,
        stockStatus,
        alternativeStore,
        selectedStoreClosedToDisplay,
        alternativeStoreClosedToDisplay,
        frontQty,
        rearQty,
        rearProduct,
        frontProduct,
        splitFitment,
        isSplitFitment,
        frontPriceDisplay,
        rearPriceDisplay,
        rearSpecReading,
        splitSavings,
        splitSavingsDisplay,
        splitTotalDisplay,
        splitCartLabel,
        mainCartLabel,
        canAddSplit,
        mainCartState,
        splitCartState,
        showFloatingCart,
        combinedStockLoading,
        overallStockStatus,
        buttonValue,
        productDiscountDisplay,
        currentPriceDisplay,
        afterpayInstallmentDisplay,
        vehicleFitLabel,
        vehicleFitStatus,
        buyItNow,
        hideModal,
        isImageZoomOpen,
        zoomImageSrc,
        zoomImageAlt,
        imageZoomOverlayRef,
        openImageZoom,
        closeImageZoom,
        addToCart,
        sendEnquiry,
        openStoreSelector,
        switchToStore,
        updateSplitQty,
        rearStockStatus,
        isInCompare,
        toggleCompare,
        faqArray,
        frontSplitTitle,
        rearSplitTitle,
        overrideFrontProduct,
        frontUnavailable,
        prevCollectionStripProducts,
        prevCollectionStripLoading,
        prevCollectionStripTrackRef,
        compareTableRows,
        openFullCompare,
        formatStripPrice,
        scrollPrevCollectionStrip,
        centerCurrentStripCard,
        availabilityString,
        notPuncture,
        isServiceProduct,
        unitLabelSingular,
        promoStore,
        pdpPromoEndDate,
        pdpBestDealText,
      };
    },
  });

  if (window.VueAppGlobals?.pinia) PDP.use(window.VueAppGlobals.pinia);
  PDP.mount('#PDP');
}

if (window.Vue && window.Pinia) {
  vuePDP();
} else {
  window.addEventListener('vue-ready', vuePDP);
}
